import bem from '../../../utils/bem';

const Credential = ({ image, label, year, modifiers = [], extra = [] }) => {
  return (
    <div
      className={bem('credential', modifiers, '', [
        'flex',
        'items-center',
        ...extra,
      ])}
    >
      {image && (
        <div className="credential__image">
          {image.markup ? (
            <span dangerouslySetInnerHTML={{ __html: image.markup }} />
          ) : (
            <img src={image.url} alt={image.alt} width="76" height="76" />
          )}
        </div>
      )}
      <div>
        <div className="credential__label">{label}</div>
        {year && (
          <div className="credential__data">
            {Drupal.t('Since')} {year}
          </div>
        )}
      </div>
    </div>
  );
};

export default Credential;
